import { useState, ChangeEvent, KeyboardEvent } from "react";
import { AuthSignInSubPage, AuthSignInInput, AuthContentTitleWrapper, AuthContentTitle } from "../authBarStyling";
import { useToast } from "../../toast/ToastContext";
import ContinueBtn from "../../btn/continueBtn/continueBtn";
import styled from "styled-components";

const LogoImage = styled.img`
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    height: 28px;
    width: auto;
    z-index: 103;

    @media (min-width: 768px) {
        top: 24px;
        height: 32px;
    }
`;

interface NewPasswordPopupProps {
    setPageName: (pageName: string) => void;
    setNewPassword: (newPassword: string) => void;
    newPassword: string;
    handleKeyboardDismiss: () => void;
}

const NewPasswordPopup: React.FC<NewPasswordPopupProps> = ({ setPageName, setNewPassword, newPassword, handleKeyboardDismiss }) => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordInvalid, setPasswordInvalid] = useState(false);
    const { showToast } = useToast();

    const checkPassword = async (): Promise<void> => {
        if (password.length < 8) {
            showToast("Password must be at least 8 characters long", "error");
            setPasswordInvalid(true);
            return;
        }

        if (password !== confirmPassword) {
            showToast("Passwords do not match", "error");
            setPasswordInvalid(true);
            return;
        }

        setPasswordInvalid(false);
        setNewPassword(password);
        setPageName("SignInVerificationPopup");
    };

    return (
        <div>
            <LogoImage src="https://d292awxalydr86.cloudfront.net/Branding/Anystay.svg" alt="Anystay Logo" />
            <AuthSignInSubPage>
                <AuthContentTitleWrapper>
                    <AuthContentTitle>Create a new password</AuthContentTitle>
            </AuthContentTitleWrapper>
            <AuthSignInInput
                    value={password}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                    invalid={passwordInvalid}
                    style={{ width: "100%", margin: "0", fontSize: "16px", borderRadius: "12px" }}
                placeholder="New password"
                type="password"
                name="password"
                    onKeyDown={async (e: KeyboardEvent<HTMLInputElement>) => (e.key === "Enter" ? await checkPassword() : null)}
                    onBlur={handleKeyboardDismiss}
                />
                <AuthSignInInput
                    value={confirmPassword}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setConfirmPassword(e.target.value)}
                    invalid={passwordInvalid}
                    style={{ width: "100%", margin: "16px 0 0 0", fontSize: "16px", borderRadius: "12px" }}
                    placeholder="Confirm password"
                    type="password"
                    name="confirmPassword"
                    onKeyDown={async (e: KeyboardEvent<HTMLInputElement>) => (e.key === "Enter" ? await checkPassword() : null)}
                onBlur={handleKeyboardDismiss}
            />
                <ContinueBtn
                    style={{ position: "relative", marginTop: "16px" }}
                    continueType="button"
                    round={true}
                    isLoading={false}
                    disabled={false}
                    onClick={checkPassword}
                    background={"black"}
                >
                    Continue
                </ContinueBtn>
            </AuthSignInSubPage>
            </div>
    );
};

export default NewPasswordPopup;
